export class StrippedMacFilter {
    public static $name = 'strippedMacFilter';
    public static Factory() {
        return function (value: string): string {
            const regex = /[a-fA-F0-9]{12}/g;
            if (regex.test(value)) {
                const splitted = value.match(/.{2}/g);
                return splitted.join(':');
            }
            return value;
        };
    }
}
